export default __webpack_public_path__ + "static/media/2009-AMcover.2c15d0c2.png";